function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Remote = function Remote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size <= 16 ? 0.8 : 0,
    stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M14.71 2.12c.04.39.37.68.75.68h.06l.091-.003c.079-.004.185-.009.316-.004q.06.014.123.017c.75.03 2.2.3 3.52 1.62s1.6 2.75 1.65 3.48c.03.4.36.7.75.7h.04a.75.75 0 0 0 .7-.8c-.06-.95-.4-2.77-2.08-4.44-1.614-1.604-3.394-1.981-4.383-2.053a1 1 0 0 0-.127-.017c-.35-.03-.61-.01-.73 0-.41.04-.72.41-.68.82m-6.33 20.6c-.74 0-1.43-.29-1.94-.81l-4.35-4.35c-.52-.52-.81-1.21-.81-1.94s.29-1.42.81-1.94l7.73-7.73c1.04-1.04 2.85-1.04 3.89 0l1.343 1.343a1.17 1.17 0 0 1 1.654 1.654L18.06 10.3a2.73 2.73 0 0 1 0 3.88l-7.73 7.73c-.52.52-1.21.81-1.94.81zm3.37-16.08c-.32 0-.64.12-.88.37l-7.73 7.73a1.234 1.234 0 0 0 0 1.76l4.35 4.35c.47.47 1.29.47 1.77 0l7.73-7.73a1.234 1.234 0 0 0 0-1.76l-4.35-4.35c-.24-.24-.56-.37-.88-.37zm-.09 4.78c-.19 0-.38-.07-.53-.22l-.94-.94a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.94.94c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22m2.07 2.39c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-.94-.94a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06zm-3.3 4.05c-.19 0-.38-.07-.53-.22l-1.245-1.245L7.41 17.64c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l1.245-1.245L6.35 14.09a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.245 1.245L9.9 13.03c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-1.245 1.245 1.245 1.245c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22m8.54-8.85h-.07a.756.756 0 0 1-.68-.81v-.005c0-.087.01-.875-.75-1.635-.82-.82-1.64-.79-1.67-.78a.743.743 0 0 1-.8-.69c-.03-.41.26-.77.67-.8h.018c.183-.009 1.561-.07 2.812 1.19 1.34 1.34 1.22 2.79 1.21 2.86a.75.75 0 0 1-.75.68z",
    clipRule: "evenodd"
  }));
};
export default Remote;
Remote.displayName = 'Remote';